import { render, staticRenderFns } from "./MarketingView.vue?vue&type=template&id=022aa5c7&"
import script from "./MarketingView.vue?vue&type=script&lang=js&"
export * from "./MarketingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports